import { ChevronLeft, ChevronRight } from "lucide-react";
import { formatDay, type PlaceForecast } from "../lib/weather";
import { areaDaySummary } from "../lib/area-weather";
import { WeatherIcon } from "./WeatherIcon";

type Props = { places: PlaceForecast[]; dates: string[]; selected: number; onSelect: (index: number) => void };

export function DayRail({ places, dates, selected, onSelect }: Props) {
  return <div className="day-rail" aria-label="Meteo dei giorni nell’area visibile">
    <span className="day-reference">Sole nell’area visibile</span>
    <button className="icon-button rail-arrow" disabled={selected === 0} onClick={() => onSelect(selected - 1)} aria-label="Giorno precedente"><ChevronLeft /></button>
    <div className="day-list">{dates.map((date, index) => {
      const summary = areaDaySummary(places, date);
      return <button key={date} className={`day-chip ${selected === index ? "is-active" : ""}`} onClick={() => onSelect(index)} aria-pressed={selected === index} data-tooltip={summary.total ? `${summary.sunny} mete soleggiate su ${summary.total} nell’area visibile. Il sole indica almeno metà delle mete soleggiate; sole e nuvole indicano alcune mete soleggiate.` : "Nessuna previsione disponibile nell’area visibile"}>
        <span className="day-label">{index === 0 ? "Oggi" : index === 1 ? "Domani" : formatDay(date)}</span>
        {summary.total > 0 && <span className={`day-weather weather-${summary.kind}`}><WeatherIcon kind={summary.kind} size={18} /></span>}
        <strong>{summary.total ? `${summary.percentage}%` : "—"}</strong>
        <small className="day-sunshine">{summary.total ? `${summary.sunny} mete soleggiate` : "Dati non disponibili"}</small>
      </button>;
    })}</div>
    <button className="icon-button rail-arrow" disabled={selected >= dates.length - 1} onClick={() => onSelect(selected + 1)} aria-label="Giorno successivo"><ChevronRight /></button>
  </div>;
}
